import { configService } from "../Config/ConfigService";
import Payment from "./Payment";
import { IPaymentProcessor, PaymentProcesserEnum } from "./PaymentProcessor";

class AffirmClient implements IPaymentProcessor {
    
  constructor() {
        
  }

  getPaymentProcessorId(): PaymentProcesserEnum {
    return PaymentProcesserEnum.Affirm;
  }

  tokenize(payment: Payment): Promise<Payment> {
    return Promise.resolve(payment);
  }

  public async initializeAffirm() {
      var config = await configService.getConfiguration();
      var affirmConfig = {
          public_api_key:  config.Affirm.PublicApiKey,
          script:          config.Affirm.Script
        };

        var affirmConfigString = "_affirm_config = " + JSON.stringify(affirmConfig) + ';';
        var affirmFunction = '(function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=!0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");';

      const script = document.createElement('script');
      script.crossOrigin = 'anonymous';
      
      try {
          script.appendChild(document.createTextNode(affirmConfigString));
          script.appendChild(document.createTextNode(affirmFunction));
          document.body.appendChild(script);
        } catch (e) {
          script.text = affirmConfig + ' ' + affirmFunction;
          document.body.appendChild(script);
        }
      
      document.body.appendChild(script);
  }
  
}

export const affirmClient = new AffirmClient();